import { render, staticRenderFns } from "./sameRepeatList.vue?vue&type=template&id=170e0ba9&"
import script from "./sameRepeatList.vue?vue&type=script&lang=js&"
export * from "./sameRepeatList.vue?vue&type=script&lang=js&"
import style0 from "./sameRepeatList.vue?vue&type=style&index=0&id=170e0ba9&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports